import { v4 as uuidv4 } from 'uuid';
import { ComponentType, type IComponentSchema } from '../../types';
import { JsonFieldType } from '../../../types';
import type { ISimpleTriggerActionButtonProps } from '.';

export const generate = (
  props?: Partial<IComponentSchema<ISimpleTriggerActionButtonProps>>
): IComponentSchema<ISimpleTriggerActionButtonProps> => {
  const id = uuidv4();

  return {
    type: JsonFieldType.VOID,
    name: props?.name || id,
    title: props?.title || 'Simple Action Trigger Button',
    'x-designable-id': id,
    'x-index': props?.['x-index'] || 0,
    'x-component': ComponentType.SimpleTriggerActionButton,
    'x-component-props': {
      text: props?.['x-component-props']?.text || 'Action',
    },
    'x-component-props-config': {},
  };
};
